import request from '@/utils/request'


// 查询活动信息列表
export function listActivity(query) {
    return request({
        url: '/h5/activity/list',
        method: 'get',
        params: query
    })
}

// 查询活动信息详情
export function listActivityById(id) {
    return request({
        url: '/h5/activity/'+id,
        method: 'get',
    })
}

// 查询待审核活动日程信息列表
export function listCheckSunActivity(query) {
    return request({
        url: '/h5/activity/checkSunList',
        method: 'get',
        params: query
    })
}

// 查询待参加活动日程信息列表
export function listJoinSunActivity(query) {
    return request({
        url: '/h5/activity/joinSunList',
        method: 'get',
        params: query
    })
}

// 查询服务记录活动信息列表
export function listUserFlowActivity(query) {
    return request({
        url: '/h5/activity/UserFlowActivity',
        method: 'get',
        params: query
    })
}
